class WorkFlowStepWarningController {
    /*@ngInject*/
    constructor($rootScope, companyService, jobService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.companyService = companyService;
        this.jobService = jobService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        //flags
        this.isDetailsFetched = false;
        this.showDetailsFlag = false;
        this.requisitions = [];
        this.clientOrBus = [];
        if (this.stepName.includes("Verification")) {
            this.stepName = "Verification";
        }
        this.stepDetails = {
            companyId: this.companyId,
            workflowStep: this.stepName
        };
        if (this.context == 'clientOrBu') {
            this.stepDetails.clientOrBuId = this.clientOrBuId;
        }
        this.getDetails();
    }
    getDetails() {
        if (this.context == 'clientOrBu') {
            this._getRequisitions();
        }
        else {
            this._getClientsOrBus();
        }
    }
    _getRequisitions() {
        this.jobService.getRequisitionsInWorkFlowStep(this.stepDetails, (data) => {
            this.isDetailsFetched = true;
            this.requisitions = data;
            this._setCountInMessage(this.requisitions.length);
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getClientsOrBus() {
        this.companyService.getWorkFlowStepClientOrBuDetails(this.stepDetails, (data) => {
            this.isDetailsFetched = true;
            this.clientOrBus = data;
            this._setCountInMessage(this.clientOrBus.length);
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setCountInMessage(count) {
        let wordsInMessage = this.message.split(' ');
        wordsInMessage[0] = count;
        this.message = wordsInMessage.join(' ');
    }
    showDetails() {
        this.showDetailsFlag = true;
    }
    close() {
        if (this.successCallback) {
            this.successCallback();
        }
    }
}
WorkFlowStepWarningController.$inject = ['$rootScope', 'companyService', 'jobService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './work-flow-step-warning.html';
import * as TEMPLATE from 'raw-loader!./work-flow-step-warning.html';
export const WorkFlowStepWarningComponent = {
    selector: 'workFlowStepWarning',
    component: {
        bindings: {
            context: '@',
            companyId: '@',
            clientOrBuId: '@',
            message: '@',
            stepName: '@',
            successCallback: '&',
        },
        controller: WorkFlowStepWarningController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/workFlowStepWarning/work-flow-step-warning.html'
    }
};
//# sourceMappingURL=work-flow-step-warning.component.js.map